import { createSelector } from 'reselect'

import { EMPTY_ARRAY } from 'utils/emptyConstants'

import { AUTH_FILTER_TO_STATUSES, PAGE_SIZE } from './constants'

const selectVendorProtectionSelf = (state) => state.vendorprotection.self

export const selectVendorQuery = (state) => selectVendorProtectionSelf(state).query
export const selectVendorTotal = (state) => selectVendorProtectionSelf(state).total
export const selectVendorSummary = (state) => selectVendorProtectionSelf(state).summary
export const selectVendorRowsLoading = (state) => selectVendorProtectionSelf(state).rowsLoading
export const selectVendorRowsError = (state) => selectVendorProtectionSelf(state).rowsError
export const selectVendorSummaryError = (state) => selectVendorProtectionSelf(state).summaryError
export const selectVendorSelection = (state) => selectVendorProtectionSelf(state).selected
export const selectVendorCreating = (state) => selectVendorProtectionSelf(state).creating
export const selectVendorCreateError = (state) => selectVendorProtectionSelf(state).createError
export const selectVendorImporting = (state) => selectVendorProtectionSelf(state).importing
export const selectVendorImportResult = (state) => selectVendorProtectionSelf(state).importResult
export const selectVendorImportError = (state) => selectVendorProtectionSelf(state).importError
export const selectVendorLastRemoved = (state) => selectVendorProtectionSelf(state).lastRemoved
export const selectVendorSyncing = (state) => selectVendorProtectionSelf(state).syncing
// null until the tenant's setting has loaded.
export const selectAutoDetection = (state) => selectVendorProtectionSelf(state).autoDetection
export const selectAutoDetectionSaving = (state) =>
  selectVendorProtectionSelf(state).autoDetectionSaving

const selectVendorFetchedRows = (state) => selectVendorProtectionSelf(state).rows
const selectRecentVendor = (state) => selectVendorProtectionSelf(state).recentVendor

export const selectRecentVendorId = createSelector(
  selectRecentVendor,
  (vendor) => vendor?.id ?? null
)

// A new vendor has no metrics, so the default sort buries it. Held on top.
export const selectVendorRows = createSelector(
  selectVendorFetchedRows,
  selectRecentVendor,
  (rows, recent) => {
    if (!recent) return rows
    const own = rows.find((row) => row.id === recent.id) || recent
    return [own, ...rows.filter((row) => row.id !== recent.id)].slice(0, PAGE_SIZE)
  }
)

export const selectVendorListParams = createSelector(selectVendorQuery, (query) => ({
  limit: PAGE_SIZE,
  offset: (query.page - 1) * PAGE_SIZE,
  window: query.window,
  search: query.search.trim(),
  authStatus: AUTH_FILTER_TO_STATUSES[query.authStatus] || EMPTY_ARRAY,
  sort: query.sort,
  order: query.sort === 'DEFAULT' ? undefined : query.order,
}))
